import React, {Component} from 'react';

//library
// import TextareaAutosize from 'react-textarea-autosize';
import moment from 'moment';

import { CSSTransition } from 'react-transition-group';

//css
import styles from '../../static/css/pageStyleModules/thanksEditAndAddMode.module.scss';

// settingFile
import {validation} from '../../static/js/settingFile/validationData.js';

//controllerAPI
import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI.js';

//component
import MemberSelectComponent from '../components/inputComponent/MemberSelectComponent';

import DatePicker from 'react-mobile-datepicker';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent';
import ManipulateHeader from '../layouts/header/ManipulateHeader';

export default class ThanksEditAndAdd extends Component {

    constructor(props){
        super(props);
        this.state = {
            titleToEdit:'',
            memberIdToEdit:null,
            memoToEdit:'',
            dateToEdit:moment().toDate(),
            thanksCheckToEdit:false,
            
            memberName:'ななしさん',
            head:'basic',
            eyes:'basic',
            eyeblows:'none',
            mouth:'basic',
            color:'#666666',

            datePickerIsOpen :false,
            memberSelecterIsOpen :false,

            memoTextLimit:validation.thanksMemoMax,

        }

        this.titleInputRef = React.createRef();
    }

    componentWillMount = () => {
        if(this.props.thankId !== undefined){
            //editMode
            //情報をgetしてきて入れる
            ThanksControllerAPI.show(this.props.thankId)
            .then((result) => {
                const thanksData = result.data;
                
                this.setState({
                    titleToEdit:thanksData.Thanks.title,
                    memberIdToEdit:thanksData.Thanks.member_id,
                    memoToEdit:thanksData.Thanks.memo,
                    dateToEdit:moment(thanksData.Thanks.date).toDate(),//YYYYMMDDからDate型に変換。datePickerライブラリのため。編集時のみDate型に。
                    thanksCheckToEdit:thanksData.Thanks.check,
                    
                    memberName:thanksData.Members.name,
                    head:thanksData.Members.head,
                    eyes:thanksData.Members.eyes,
                    eyeblows:thanksData.Members.eyeblows,
                    mouth:thanksData.Members.mouth,
                    color:thanksData.Members.color,    
                })
                
            })
        }else{
            //addMode
            //一応初期化しておく。
            //ななしさん用のデータを持つなら、ここでgetするようにする
            this.setState({
                titleToEdit:'',
                memberIdToEdit:null,
                memoToEdit:'',
                dateToEdit:new Date(),
                thanksCheckToEdit:false,
                
                memberName:'ななしさん',
                head:'basic',
                eyes:'basic',
                eyeblows:'none',
                mouth:'basic',
                color:'#666666',
            })
        }
        
    }

    componentDidMount = () => {

        process.nextTick(() => {
            if(this.props.thankId === undefined){
                this.titleInputRef.current.focus();
            }
        })
    }

    // backToPrePage = () => {
    //     if(this.props.thankId !== undefined){
    //         this.props.onCancelButtonClick('thanksInfoMode',this.props.thankId);
    //     }else{
    //         this.props.onCancelButtonClick('thanksListMode',null);
    //     }
    // }

    datePickedHandleSelect = (time) => {
        this.setState({ dateToEdit:time, datePickerIsOpen: false });
    } 

    datePickedHandleCancel = () => {
        this.setState({ datePickerIsOpen: false });
    }

    memberSelect = (id,name,head,eyes,eyeblows,mouth,color) => {
        this.setState({
            memberIdToEdit:id,
            memberName:name,
            head:head,
            eyes:eyes,
            eyeblows:eyeblows,
            mouth:mouth,
            color:color,
            memberSelecterIsOpen:false,
        })
    }

    //ネストされたものを双方向データバインディングをする上でJSON.perseがDate型で使えないので、あきらめる。
    //ひとつひとつパラメーターをいじって、送信するときにまとめる。
    changeThanksTitle = (event) => {
        this.setState({titleToEdit:event.target.value});
    }
    
    changeThanksMemo = (event) => {
        this.setState({memoToEdit:event.target.value});
    }

    submitThanks = () => {

        if(this.state.titleToEdit.length === 0){
            this.props.onInfoDisplayCall('cancel','#999999','見出しを入れてください');
            return;
        }


        if(this.state.memoToEdit.length > this.state.memoTextLimit) {
            this.props.onInfoDisplayCall('cancel','#999999','文字数オーバーです');
            return;
        }

        //データ作成
        const thankDataForPost = {
            id:this.props.thankId,
            title:this.state.titleToEdit,
            member_id:this.state.memberIdToEdit,
            memo:this.state.memoToEdit,
            date:this.state.dateToEdit,
            check:this.state.thanksCheckToEdit,
        }

        ThanksControllerAPI.store(thankDataForPost)
        .then((result) => {
            this.props.onInfoDisplayCall('facedHeart','hsl(6,77%,62%)','保存しました')
            this.props.onCancelButtonClick();
            this.props.onSubmitDone(result.data.id);            
        })
        .catch((error) => {
            console.log(error.message);
        })

    }


    render() {

        const thanksDate = (dateIntString) => {
            if(dateIntString !== undefined){
                const dateString = moment(dateIntString).format('YYYY年MM月DD日')
                //多言語対応
                const dayOfTheWeek = moment(dateIntString).toDate().getDay();
                const dayOfTheWeekArray = ['Sun','Mon','Tue','Wed','Thu','Fry','Sat']
                
                return dateString + ' (' + dayOfTheWeekArray[dayOfTheWeek] + ')';
            }else{
                return '';
            }
        }

        //多言語対応
        const datePickerText = {
            ok:'OK',
            cancel:'キャンセル'
        }

        const textMaxedOutStyle = () => {
            if(this.state.memoToEdit.length > this.state.memoTextLimit){
                return {color:'hsl(6,77%,62%)',transition:'color .2s'}
            }else{
                return {color:'#999999',transition:'color .2s'};
            }
        }

        return (

            <div className={styles['inputBaseArea']}>
              <div className={styles['submitArea']}>
                <ManipulateHeader
                leftIcon={'cancel'} 
                leftIconColor={'#999999'}
                onLeftButtonClick={() => this.props.onCancelButtonClick()}
                rightIcon={'submit'}
                rightIconColor={'hsl(93,54%,43%)'}
                onRightButtonClick={this.submitThanks} 
                />
              </div>

              <div className={styles['inputArea']}>

                <div className={styles['dateInputArea'] + ' thanksLogButton touchActiveDark'} onClick={() => this.setState({datePickerIsOpen:true})}>
                  <span>{thanksDate(this.state.dateToEdit)}</span>
                </div>

                <CSSTransition
                in={this.state.datePickerIsOpen}
                timeout={200}
                classNames="simpleFade200"
                unmountOnExit
                mountOnEnter
                >
                  <DatePicker 
                  value={this.state.dateToEdit}
                  isOpen={this.state.datePickerIsOpen}
                  min={new Date(1, 0, 1)} 
                  max={new Date(2100, 0, 1)} 
                  confirmText={datePickerText.ok}
                  cancelText={datePickerText.cancel}
                  onSelect={this.datePickedHandleSelect}
                  onCancel={this.datePickedHandleCancel}
                  />
                </CSSTransition>

                <div className={styles['titleInputArea']}>
                  <input type="text"
                  className="thanksLogInput"
                  value={this.state.titleToEdit !== undefined ? this.state.titleToEdit : ''} 
                  maxLength={validation.thanksTitleMax}
                  placeholder="どんなこと？"
                  onChange={this.changeThanksTitle}
                  ref={this.titleInputRef}
                  />
                </div>

                <div className={styles['memberSelectButton'] + ' thanksLogButton touchActiveDark'}
                onClick={() => this.setState({memberSelecterIsOpen:true})}>
                  <span>
                    {this.state.memberName !== null ? this.state.memberName : 'ななしさん'}
                  </span>
                  <div className={styles['memberIcon']}>
                    <FaceIconBaseComponent 
                    head={this.state.head !== null ? this.state.head : 'basic'}
                    eyes={this.state.eyes !== null ? this.state.eyes : 'basic'}
                    eyeblows={this.state.eyeblows !== null ? this.state.eyeblows : 'basic'}
                    mouth={this.state.mouth !== null ? this.state.mouth : 'basic'}
                    fillColor={this.state.color !== null ? this.state.color : '#888888'}
                    />
                  </div>
                </div>

                <div className={styles['memoInputArea']}>
                  <textarea placeholder="メモ..." rows="6"
                  className="thanksLogInput"
                  value={this.state.memoToEdit !== undefined ? this.state.memoToEdit : ''}
                  onChange={this.changeThanksMemo} />
                  <div className={styles['textCounter']} style={textMaxedOutStyle()}>
                    <span>{this.state.memoToEdit.length}</span>
                    <span> / </span>
                    <span>{this.state.memoTextLimit}</span>
                  </div>
                </div>

                <div className={styles['thanksCheckArea']}>
                
                </div>

              </div>

              <CSSTransition
              in={this.state.memberSelecterIsOpen}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <div className={styles['memberSelectModalBase']}>
                  <div className={styles['memberSelectModal']}>
                    <MemberSelectComponent 
                    selectedMemberId={this.state.memberIdToEdit}
                    onEnterClick={this.memberSelect}
                    onCancelClick={() => this.setState({memberSelecterIsOpen:false})}
                    />
                  </div>
                </div>
              </CSSTransition>
            </div>

        )
    }

};